import PromoBanner from '../components/Promo/PromoBanner/PromoBanner';
import ShowCase from '../components/ShowCase/ShowCase';
import PromoTextPicture from '../components/Promo/PromoTextPicture/PromoTextPicture';
import PreviewPromoBanner from '../../../../../../../assets/images/main-page-blocks/promo-banner-100.svg';
import PreviewPromoBannerScroll from '../../../../../../../assets/images/main-page-blocks/promo-banner-scroll.svg';
import PreviewPromoTextImage from '../../../../../../../assets/images/main-page-blocks/promo-text-image.svg';
import PreviewPromoTextImageReverse from '../../../../../../../assets/images/main-page-blocks/promo-text-image-reverse.svg';
import PreviewShowcaseLine1 from '../../../../../../../assets/images/main-page-blocks/showcase-line-1.svg';
import PreviewShowcaseLine2 from '../../../../../../../assets/images/main-page-blocks/showcase-line-2.svg';
import PreviewShowcaseLine3 from '../../../../../../../assets/images/main-page-blocks/showcase-line-3.svg';
import PreviewShowcaseLine1WithImage from '../../../../../../../assets/images/main-page-blocks/showcase-line-1-with-image.svg';
import PreviewShowcaseLine2WithImage from '../../../../../../../assets/images/main-page-blocks/showcase-line-2-with-image.svg';
import PreviewShowcaseLine3WithImage from '../../../../../../../assets/images/main-page-blocks/showcase-line-3-with-image.svg';
import PreviewShowcaseScroll from '../../../../../../../assets/images/main-page-blocks/showcase-scroll.svg';
import PreviewShowcaseLine1WithHero from '../../../../../../../assets/images/main-page-blocks/showcase-line-1-with-hero.svg';
import PreviewShowcaseLine2WithHero from '../../../../../../../assets/images/main-page-blocks/showcase-line-2-with-hero.svg';
import PreviewShowcaseLine3WithHero from '../../../../../../../assets/images/main-page-blocks/showcase-line-3-with-hero.svg';

import PreviewCustomBlock0 from '../../../../../../../assets/images/main-page-blocks/custom-block-0.svg';
import PreviewCustomBlock1 from '../../../../../../../assets/images/main-page-blocks/custom-block-1.svg';
import PreviewCustomBlock2 from '../../../../../../../assets/images/main-page-blocks/custom-block-2.svg';
import PreviewCustomBlock3 from '../../../../../../../assets/images/main-page-blocks/custom-block-3.svg';
import PreviewCustomBlock4 from '../../../../../../../assets/images/main-page-blocks/custom-block-4.svg';
import PreviewCustomBlock5 from '../../../../../../../assets/images/main-page-blocks/custom-block-5.svg';
import PreviewCustomBlock6 from '../../../../../../../assets/images/main-page-blocks/custom-block-6.svg';
import PreviewCustomBlock7 from '../../../../../../../assets/images/main-page-blocks/custom-block-7.svg';
import PreviewCustomBlock8 from '../../../../../../../assets/images/main-page-blocks/custom-block-8.svg';
import PreviewCustomBlock9 from '../../../../../../../assets/images/main-page-blocks/custom-block-9.svg';

import PreviewAllCategoriesImg from '../../../../../../../assets/images/main-page-blocks/all-categories-img.svg';
import PreviewAllCategoriesImgText from '../../../../../../../assets/images/main-page-blocks/all-categories-img-text.svg';

export const TYPE_MAP = {
    'promo-banner-100%': {
        title: 'Большой промо-баннер',
        form: PromoBanner,
        preview: PreviewPromoBanner,
    },
    'promo-banner-scroll': {
        title: 'Карусель баннеров',
        form: PromoBanner,
        preview: PreviewPromoBannerScroll,
    },
    'promo-text-image': {
        title: 'Текст и изображение (изображение слева)',
        form: PromoTextPicture,
        preview: PreviewPromoTextImage,
    },
    'promo-text-image-reverse': {
        title: 'Текст и изображение (изображение справа)',
        form: PromoTextPicture,
        preview: PreviewPromoTextImageReverse,
    },
    'showcase-line-1': {
        title: 'Витрина товаров: 1 ряд',
        form: ShowCase,
        preview: PreviewShowcaseLine1,
    },
    'showcase-line-2': {
        title: 'Витрина товаров: 2 ряда',
        form: ShowCase,
        preview: PreviewShowcaseLine2,
    },
    'showcase-line-3': {
        title: 'Витрина товаров: 3 ряда',
        form: ShowCase,
        preview: PreviewShowcaseLine3,
    },
    'showcase-line-1-with-image': {
        title: 'Витрина с баннером: 1 ряд',
        form: ShowCase,
        preview: PreviewShowcaseLine1WithImage,
    },
    'showcase-line-2-with-image': {
        title: 'Витрина с баннером: 2 ряда',
        form: ShowCase,
        preview: PreviewShowcaseLine2WithImage,
    },
    'showcase-line-3-with-image': {
        title: 'Витрина с баннером: 3 ряда',
        form: ShowCase,
        preview: PreviewShowcaseLine3WithImage,
    },
    'showcase-scroll': {
        title: 'Витрина карусель',
        form: ShowCase,
        preview: PreviewShowcaseScroll,
    },
    'showcase-line-1-with-hero': {
        title: 'Витрина с главным товаром: 1 ряд',
        form: ShowCase,
        preview: PreviewShowcaseLine1WithHero,
    },
    'showcase-line-2-with-hero': {
        title: 'Витрина с главным товаром: 2 ряда',
        form: ShowCase,
        preview: PreviewShowcaseLine2WithHero,
    },
    'showcase-line-3-with-hero': {
        title: 'Витрина с главным товаром: 3 ряда',
        form: ShowCase,
        preview: PreviewShowcaseLine3WithHero,
    },
    'custom-block-0': {
        title: 'Кастомный блок #0',
        form: null,
        preview: PreviewCustomBlock0,
    },
    'custom-block-1': {
        title: 'Кастомный блок #1',
        form: null,
        preview: PreviewCustomBlock1,
    },
    'custom-block-2': {
        title: 'Кастомный блок #2',
        form: null,
        preview: PreviewCustomBlock2,
    },
    'custom-block-3': {
        title: 'Кастомный блок #3',
        form: null,
        preview: PreviewCustomBlock3,
    },
    'custom-block-4': {
        title: 'Кастомный блок #4',
        form: null,
        preview: PreviewCustomBlock4,
    },
    'custom-block-5': {
        title: 'Кастомный блок #5',
        form: null,
        preview: PreviewCustomBlock5,
    },

    'custom-block-6': {
        title: 'Кастомный блок #6',
        form: null,
        preview: PreviewCustomBlock6,
    },

    'custom-block-7': {
        title: 'Кастомный блок #7',
        form: null,
        preview: PreviewCustomBlock7,
    },
    'custom-block-8': {
        title: 'Кастомный блок #8',
        form: null,
        preview: PreviewCustomBlock8,
    },
    'custom-block-9': {
        title: 'Кастомный блок #9',
        form: null,
        preview: PreviewCustomBlock9,
    },
    'all-categories-img': {
        title: 'Первый уровень категорий (Без названий)',
        form: null,
        preview: PreviewAllCategoriesImg,
    },
    'all-categories-img-text': {
        title: 'Первый уровень категорий (C названиями)',
        form: null,
        preview: PreviewAllCategoriesImgText,
    },
}
